import { createTelemetryObject, createTelemetry } from '@shared/core/analytics';
import type { GuestLanguageSelectorSurface } from './GuestLanguageSelector.types';

const guestLanguageSelectorTelemetry = createTelemetryObject({
  actions: {
    languageSelectorOpened: (surface: GuestLanguageSelectorSurface) => ({
      action: 'ButtonInteracted',
      category: 'wedding',
      extraInfo: {
        name: 'GuestLanguageSelectorOpened',
        surface,
      },
    }),

    languageSelected: (surface: GuestLanguageSelectorSurface, fromLocale: string, toLocale: string) => ({
      action: 'ButtonInteracted',
      category: 'wedding',
      extraInfo: {
        name: 'GuestLanguageSelected',
        surface,
        fromLocale,
        toLocale,
      },
    }),
  },
});

const { TelemetryProvider, useTelemetry: useGuestLanguageSelectorTelemetry } = createTelemetry(guestLanguageSelectorTelemetry);
export { TelemetryProvider, useGuestLanguageSelectorTelemetry };
